/**
 ** 加法函数，用来得到精确的加法结果
 ** 说明：javascript的加法结果会有误差，在两个浮点数相加的时候会比较明显。这个函数返回较为精确的加法结果。
 ** 调用：accAdd(arg1,arg2)
 ** 返回值：arg1加上arg2的精确结果
 **/
export const addition = (arg1, arg2) => {
  if (!arg1) {
    arg1 = 0;
  }
  if (!arg2) {
    arg2 = 0;
  }
  arg1 = arg1.toString().replace(/\,/g, "");
  arg2 = arg2.toString().replace(/\,/g, "");

  var r1, r2, m, c;
  try {
    r1 = arg1.toString().split(".")[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = arg2.toString().split(".")[1].length;
  } catch (e) {
    r2 = 0;
  }
  c = Math.abs(r1 - r2);
  m = Math.pow(10, Math.max(r1, r2));
  if (c > 0) {
    var cm = Math.pow(10, c);
    if (r1 > r2) {
      arg1 = Number(arg1.toString().replace(".", ""));
      arg2 = Number(arg2.toString().replace(".", "")) * cm;
    } else {
      arg1 = Number(arg1.toString().replace(".", "")) * cm;
      arg2 = Number(arg2.toString().replace(".", ""));
    }
  } else {
    arg1 = Number(arg1.toString().replace(".", ""));
    arg2 = Number(arg2.toString().replace(".", ""));
  }
  return (arg1 + arg2) / m;
}

function S4() {
  return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
};

export function guid() {
  return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
}
//是否是本地访问
export function IsDevelop() {
  const hostName = ['localhost','127.0.0.1'];
  let host = location.host.toLowerCase();
  let isDevelop = false;
  hostName.forEach((item, index) => {
    if (host.indexOf(item) > -1) {
      isDevelop = true;
    }
  })
  return isDevelop;
}
//金额格式转换,添加千分位
export function DecimalFormat(s) {
  if (s==""||s == null || s == "undefined" || s == '0'||s.length<1) {
    return "";
  }
  let h = '';
  s = s.toString();
  if (s.charAt(0) == '-') {
    h = '-';
    s = s.slice(1);
  }
  if (/[^0-9\.]/.test(s)) return "NaN";
  s = s.replace(/^(\d*)$/, "$1.");
  s = (s + "00").replace(/(\d*\.\d\d)\d*/, "$1");
  s = s.replace(".", ",");
  let re = /(\d)(\d{3},)/;
  while (re.test(s)) s = s.replace(re, "$1,$2");
  s = s.replace(/,(\d\d)$/, ".$1");
  return h + s.replace(/^\./, "0.");
}
//获取code值当前路径的code值
export function getUrlParam(name) {
  let url = window.location.href
  let index = url.lastIndexOf("?");
  let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  let r = url.substr(index + 1).match(reg);
  if (r != null) {
    return unescape(r[2]);
  }
  return null;
}
//时间格式只显示00或30分钟
export function dateTimeHalfAnHourFormatter(type, value) {
  if (type === 'minute') {
    // 只显示30或00分钟
    return value % 30 === 0 ? `${value}` : '';
  }
  return value;
}
//过滤条件只显示00或30时间选项
export function dateTimeHalfAnHourFilter(type, values) {
  if (type === 'minute') {
    return values.filter(value => value % 30 === 0 || value === 0);
  }
  return values;
}
//添加指定分钟时间
export function addMinutesHalfAnHourTime(date,minutes) {
  // 获取当前时间的时间戳
  // 将时间戳转换为Date对象
  var addCurrentDate = new Date(date);
  // 将当前时间加30分钟
  addCurrentDate.setMinutes(addCurrentDate.getMinutes() + minutes);
  return addCurrentDate;
}
